<div>

  <input set-focus type="text" id="search-box" class="form-control" autocomplete="off" [(ngModel)]="term">

  @if (field == undefined) {
  <div class="search-result typology-search">
    @switch (status) {
    @case ('ok') {
    @for (type of typologies | stringFilter:term; track $index) {
    <div (click)="onSelectTypology(type)">
      {{ type.name }}
    </div>
    }
    }
    @case ('busy') {
    <div class="spinneram spinner-padding-top">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
      {{'app.loading-message'| translate}}
    </div>
    }
    }
  </div>
  }

  @if (field == 'ad-search' && term) {
  <div class="search-result">
    @for (type of typologies | stringFilter:term; track $index) {
    <div (click)="onSelectTypology(type)">
      {{ type.name }}
    </div>
    }
  </div>
  }
</div>